import React, {useCallback, useEffect, useState} from 'react';
import {document} from "../../../models/document";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {documentResultCollectionType, documentResultType} from "../../../types/Api/DocumentResultType";
import {documentHydrator} from "../../../models/hydrator/documentHydrator";
import {Loader} from "../../../components/admin/Loader";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {DocumentSortable} from "../../../components/admin/document/DocumentSortable";
import {NavLink, useNavigate} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const Order = () => {
  const navigate = useNavigate();

  const [documents, setDocuments] = useState([] as document[]);
  const [loading, setLoading] = useState(false);

  const findDocument = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'position',
      direction: 'ASC'
    });
    apiFilters.setCount(-1);

    setLoading(true);
    const result: Promise<documentResultCollectionType> = ApiService.get('/document', apiFilters) as Promise<documentResultCollectionType>;

    result
      .then((r: documentResultCollectionType) => {
        setDocuments(r._embedded.documents.map((document: documentResultType) => {
            return documentHydrator.hydrate(document);
          })
        );
      })
      .catch(() => {
        alert("Une erreur c'est produite.")
        setDocuments([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  useEffect(() => {
    findDocument();
  }, [findDocument]);

  const onSave = async (documents: document[]) => {
    await Promise.all(documents
      .map((d: document, i: number) => ({d, i}))
      .filter(({d, i}) => d.position !== i)
      .map(({d, i}) => ApiService.patch(`/document/${d.documentId}`, { param: () => {return {position: i}} }))
    );

    navigate('/admin/document');
  }

  return (
    <>
      <BoxTitle title="Ordre des documents"/>
      {loading && (
        <Loader/>
      )}
      {!loading && (
        <>
          <div className="d-flex align-content-between">
            <DocumentSortable documents={documents}/>
          </div>
          <div className="mt-2">
            <button type="button" className="btn btn-sm btn-success me-1" onClick={() => onSave(documents)}>Enregistrer</button>
            <NavLink to={`/admin/document`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux documents</NavLink>
          </div>
        </>
      )}
    </>
  );
}
